import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=6f2a2b26&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
import style0 from "./Switch.vue?vue&type=style&index=0&id=6f2a2b26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a2b26",
  null
  
)

export default component.exports